import { useEffect } from 'react';
import styles from './home.module.scss';

const HomePage = () => {
  useEffect(() => {
    window.location.href = 'https://datahippo.xyz';
  }, []);

  return (
    <div className={styles.loadingContainer}>
      <div className={styles.loadingContent}>
        <div className={styles.spinner}></div>
      </div>
    </div>
  );
};

export default HomePage;
